import {RepositoryProjectsPage as RepositoryProjectsPageContent} from '@github-ui/repository-projects'

import {renderIssuesSidebar} from '../components/sidebar/render-issues-sidebar'
import {AnalyticsWrapper} from './AnalyticsWrapper'

export function RepositoryProjectsPage() {
  return (
    <AnalyticsWrapper category="Repository Projects Index">
      <RepositoryProjectsPageContent renderSidebar={renderIssuesSidebar} />
    </AnalyticsWrapper>
  )
}
